/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react';
import { Avatar, Checkbox, LinearProgress, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { LayoutBaseDeFolha, } from '../../../shared/layouts';
import { Environment } from '../../../shared/environment';
import { FerramentasDaListagemFolhaCheque } from '../../../shared/components';
import { DecimoService, ITipoPgtoChequeDecimo } from '../../../shared/services/api/rh/DecimoTerceiro/DecimoService';
import PDFCheques from '../folha/ImprmirCheque';
import ImprTipoPagamentoCheque from '../folha/ImprTipoPagamentoCheque';


export const ListagemFolhaChequeDecimo: React.FC = () => {
  const { ano = '' } = useParams<'ano'>();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [rows, setRows] = useState<ITipoPgtoChequeDecimo[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [fazenda, setFazenda] = useState('');
  const [nomefazenda, setNomeFazenda] = useState('');


  // const pagina = useMemo(() => {   
  //   return Number(searchParams.get('pagina') || '1');
  // }, [searchParams]);

  const handleFazenda = (uuid: string, nome: string) => {
    setIsLoading(true);
    setNomeFazenda(nome);
    DecimoService.TipoPagamentoCheque(Number(ano), uuid)
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          alert(result.message);
        } else {
          setRows(result);
        }
      });
  };

  const handleImprimirFolha = () => {
    // ImprTipoPagamentoCheque(rows, `${id}/${ano}`, nomefazenda);
  };

  const handleImprimirCheque = () => {
    console.log(rows);
    const filteredList = rows.filter((item) => item.marcado === true);
    console.log(filteredList);
    PDFCheques(filteredList);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = event.target;
    const index = rows.findIndex(row => row.idfolha === id);
    if (index === -1) return;
    const updatedRow = { ...rows[index], marcado: checked };
    const updatedRows = [...rows.slice(0, index), updatedRow, ...rows.slice(index + 1)];
    setRows(updatedRows);
  };

  return (
    <LayoutBaseDeFolha
      titulo='Pagamento Decimo Terceiro por Cheque'
      barraDeFerramentas={
        <FerramentasDaListagemFolhaCheque
          aoClicarEmImprimirFolha={handleImprimirFolha}
          aoClicarEmImprimirCheque={handleImprimirCheque}
          aoMudarTextoDoFazenda={handleFazenda}
        />
      }
    >
      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto', marginLeft: 3, marginRight: 2 }}>
        <Table>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ maxWidth: 10, width: 10 }} size="small" aria-label="a dense table"></TableCell>
                <TableCell>Colaborador</TableCell>
                <TableCell>CPF</TableCell>
                <TableCell align='right' sx={{ maxWidth: 100, width: 100 }}>Valor</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map(row => ( 
                <TableRow key={row.idfolha}
                  hover
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell><Avatar alt="F" src={Environment.URL_IMGFUNCIONARIO + row.urlimg} /></TableCell>
                  <TableCell>{row.nome}</TableCell>
                  <TableCell>{row.cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')}</TableCell>
                  <TableCell align='right'>{row.total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell>
                    <Checkbox
                      checked={row.marcado} id={row.idfolha} onChange={handleChange}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Table>
      </TableContainer>
    </LayoutBaseDeFolha>
  );
};